/* TODO: t() */
import React from 'react';

import ResizeSensor from './ResizeSensor';
import CrossFrameMessenger from '../../support/helpers/CrossFrameMessenger';

type Props = {
  isEnabled: boolean;
};

function EmbedResizeSensor(props: Props) {
  if (props.isEnabled) {
    return <ResizeSensor onResize={CrossFrameMessenger.onResize} />;
  } else {
    return null;
  }
}

export default EmbedResizeSensor;
